<template>
  <div>
    <modify-details
      :form="form"
      :residents="residents"
      @updated="$emit('updated')"
    />
    <div class="card">
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 back-ground-grey"
      >
        <div class="row">
          <div
            class="
              col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
              pt-0
              pb-0
              check-text-center
            "
          >
            <h5 class="mb-0 pt-1">CONFIGURAÇÕES</h5>
          </div>
          <div
            class="
              col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
              pt-0
              pb-0
              check-text-right
            "
          >
            <v-btn
              :disabled="reorder_mode"
              small
              class="btn-edit m-1"
              @click="$bvModal.show('modify_details')"
            >
              <i class="fas fa-pencil-alt mr-2 text-twenty" /> EDITAR
            </v-btn>
          </div>
        </div>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h6 class="worksansr">
          DESCRIÇÃO: <strong>{{ form.description }}</strong>
        </h6>
        <h6 class="mb-0 worksansr">
          STATUS: <strong>{{ form.status_name }}</strong>
        </h6>
        <div class="row">
          <!-- perfis -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <h6 class="upper-text color-blue">Perfis</h6>
            <div class="row" v-if="public_answer && public_read && public_edit">
              <div class="col-xl-6 pt-0 pb-0">
                <h6 class="mb-0 worksansr upper-text">todos os perfis</h6>
              </div>
              <div class="col-xl-6 pt-0 pb-0">
                <b-badge variant="success" class="mr-1"> RESPONDER </b-badge>
                <b-badge variant="secondary" class="mr-1">
                  VER RESPONDIDOS
                </b-badge>
                <b-badge variant="info" class="mr-1"> EDITAR </b-badge>
              </div>
            </div>
            <hr
              v-if="public_answer && public_read && public_edit"
              class="mb-1 mt-0"
            />
            <v-data-iterator
              v-if="!public_answer || !public_read || !public_edit"
              must-sort
              sort-by="name"
              :sort-desc="false"
              :items="form.profiles"
              :items-per-page="5"
              :hide-default-footer="form.profiles.length <= 5"
            >
              <template v-slot:item="{ item }">
                <div class="row">
                  <div class="col-xl-6 pt-0 pb-0">
                    <h6 class="mb-1 upper-text worksansr">
                      {{ item.name }}
                    </h6>
                  </div>
                  <div class="col-xl-6 pt-0 pb-0">
                    <b-badge
                      v-if="item.answer || public_answer"
                      variant="success"
                      class="mr-1"
                    >
                      RESPONDER
                    </b-badge>
                    <b-badge
                      v-if="item.read || public_read"
                      variant="secondary"
                      class="mr-1"
                    >
                      VER RESPONDIDOS
                    </b-badge>
                    <b-badge v-if="item.edit || public_edit" variant="info">
                      EDITAR
                    </b-badge>
                  </div>
                </div>
                <hr class="mb-1 mt-0" />
              </template>
            </v-data-iterator>
          </div>
          <!-- grau de dependência ou público -->
          <div
            v-if="
              form.visibility_type_value === 'DEGREE_OF_DEPENDENCE' ||
              form.visibility_type_value === 'PUBLIC'
            "
            class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
          >
            <!-- grau de dependência -->
            <template
              v-if="form.visibility_type_value === 'DEGREE_OF_DEPENDENCE'"
            >
              <h6 class="upper-text color-blue">Graus de dependência</h6>
              <h6 class="worksansr">
                Disponível para os seguintes graus de dependência:
              </h6>
              <v-data-iterator
                must-sort
                sort-by="name"
                :sort-desc="false"
                :items="form.degrees_of_dependence"
                :items-per-page="5"
                :hide-default-footer="form.degrees_of_dependence.length <= 5"
              >
                <template v-slot:default="{ items }">
                  <div v-for="item in items" :key="item.id">
                    <h6 class="mb-1 upper-text worksansr">
                      {{ item.name }}
                    </h6>
                    <hr class="mt-0 mb-1" />
                  </div>
                </template>
              </v-data-iterator>
            </template>

            <template v-if="form.visibility_type_value === 'PUBLIC'">
              <h6 class="upper-text color-blue">PÚBLICO</h6>
              <h6 class="worksansr">Disponível para todos os residentes.</h6>
            </template>

            <template v-if="form.ignored_residents.length > 0">
              <h6 class="upper-text color-blue">EXCETO PARA</h6>
              <v-data-iterator
                must-sort
                sort-by="name"
                :sort-desc="false"
                :items="form.ignored_residents"
                :items-per-page="5"
                :hide-default-footer="form.ignored_residents.length <= 5"
              >
                <template v-slot:default="{ items }">
                  <div v-for="item in items" :key="item.id">
                    <h6 class="mb-1 upper-text worksansr">
                      {{
                        residents.find((resident) => resident.id === item).name
                      }}
                    </h6>
                    <hr class="mt-0 mb-1" />
                  </div>
                </template>
              </v-data-iterator>
            </template>
          </div>
          <!-- manual -->
          <div
            v-if="form.visibility_type_value === 'MANUAL'"
            class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
          >
            <h6 class="upper-text color-blue">Residentes</h6>
            <v-data-iterator
              must-sort
              sort-by="name"
              :sort-desc="false"
              :items="form.residents"
              :items-per-page="5"
              :hide-default-footer="form.residents.length <= 5"
            >
              <template v-slot:default="{ items }">
                <div v-for="item in items" :key="item.id">
                  <h6 class="mb-1 upper-text worksansr">
                    {{ item.name }}
                  </h6>
                  <hr class="mt-0 mb-1" />
                </div>
              </template>
            </v-data-iterator>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModifyDetails from "./ModifyDetails.vue";
export default {
  name: "FormDetails",

  components: {
    ModifyDetails,
  },

  props: {
    /** @type {{
     *    name: string,
     *    description: string,
     *    rest_home_id: number,
     *    id: number,
     *    semiology_form_status_id: number,
     *    status_name: ("ABERTO"|"DISPONÍVEL"|"DESATIVADO"),
     *    status_value: ("OPEN"|"AVAILABLE"|"INACTIVE"),
     *    created_at: Date,
     *    updated_at: Date,
     *    profiles: {
     *      id: number,
     *      name: string,
     *      answer: boolean,
     *      read: boolean,
     *      edit: boolean,
     *    }[],
     *    degrees_of_dependence: { id: number, name: string, value: number }[],
     *    residents: { id: number, name: string }[],
     *  }} formulário
     */
    form: Object,
    residents: Array,
    reorder_mode: Boolean,
  },

  data() {
    return {
      loading: false,
      public_answer: false,
      public_read: false,
      public_edit: false,
    };
  },

  watch: {
    form: async function () {
      this.public_answer = this.form.profiles.every(
        (profile) => !profile.answer
      );
      this.public_read = this.form.profiles.every((profile) => !profile.read);
      this.public_edit = this.form.profiles.every((profile) => !profile.edit);
    },
  },

  methods: {
    async evOnModifyDetailsUpdated() {
      this.$emit("updated");
    },
  },
};
</script>

<style>
</style>